module.exports = __webpack_public_path__ + "static/media/paleBanner_sm2.80f2c81b.png";